<template>
  <Button
    v-if="showViewButton"
    color="text-primary"
    :title="$t('View order')"
    :icon-btn="true"
    :icon-with-background="true"
    small
    class="ma-1"
    @click="$emit('viewOrder')"
  >
    <v-icon
      size="small"
      color="primary"
    >
      mdi-eye
    </v-icon>
  </Button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Button from "@/components/input-components/Button.vue";
import {Order} from "@/entities/order";
import {ORDER_STATUS} from "@/utils/constants";
import { usePermissionsService } from '@/composables/usePermissionsService';

defineOptions({ name: "OrderGridActionView" });

const props = defineProps<{
  order: {
    type: Order,
    required: true,
  }
}>()

const emit = defineEmits<{
  viewOrder
}>()

const permissionsService = usePermissionsService()

const showViewButton = computed(() =>
  (permissionsService.hasOrderReadPermission ||
    permissionsService.hasOrderReadAllPermission) &&
  props.order.statusId !== ORDER_STATUS.draft
)
</script>
